export default __webpack_public_path__ + "static/media/floorrock-therm-rockwool-komposition_comp.8466dbed.jpg";